import { FormControl, FormGroup } from '@angular/forms';
import { AfterContentInit, Component, OnDestroy } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { BaryModalEvent, IBaryModalEvent } from './bary-modal-event';
import { SubscribedContainer } from '../app/shared/util/subscribed-container';
import { BaryComponentHelper } from '../app/shared/util/bary-component-helper';

export interface IBaryModalForm {
  action: Subject<IBaryModalEvent>;
  modalForm: FormGroup;
  model: any;
  fields: { [p: string]: string };
  CLOSE: IBaryModalEvent;
  CANCEL: IBaryModalEvent;
  SUBMIT: IBaryModalEvent;

  updateModel(form: IBaryModalEvent): void;

  handleSubmit(form: any): void;

  registerFormChanges(): void;
}

@Component({
  template: '',
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class BaryModalForm extends SubscribedContainer implements IBaryModalForm, AfterContentInit, OnDestroy {
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  modalForm!: FormGroup;
  model!: any;
  CANCEL!: IBaryModalEvent;
  CLOSE!: IBaryModalEvent;
  SUBMIT!: IBaryModalEvent;

  get fields(): { [p: string]: string } {
    return Object.keys(this.model).reduce(
      (obj, item) => ({
        ...obj,
        [item]: item,
      }),
      {}
    );
  }

  getControl(name: string): FormControl {
    return this.modalForm.get(name) as FormControl;
  }

  updateModel(form: any): void {
    Object.keys(this.model).forEach(key => {
      if (form[key] && this.model[key] !== form[key]) {
        this.model[key] = form[key];
      }
    });
  }

  registerFormChanges(): void {
    this.modalForm.valueChanges.pipe(debounceTime(300)).subscribe(form => {
      this.updateModel(form as FormGroup);
    });
  }

  ngAfterContentInit(): void {
    this.CLOSE = new BaryModalEvent({ close: true });
    this.CANCEL = new BaryModalEvent({ cancel: true });
    this.SUBMIT = new BaryModalEvent({ submit: true, value: this.model });
  }

  focusOnFirstError(): void {
    document.getElementsByClassName('ng-invalid')[0].scrollTo();
    (document.getElementsByClassName('ng-invalid')[0] as HTMLElement).focus();
  }

  handleSubmit(form: any): void {
    if (this.modalForm.invalid) {
      this.modalForm.markAllAsTouched();
      this.focusOnFirstError();
    } else {
      this.submit(form);
    }
  }

  submit(event: IBaryModalEvent): void {
    console.error('Submit function on BaryForm.ts is not overwrited !' + event);
  }

  override ngOnDestroy(): void {
    this.action.unsubscribe();
  }

  protected refreshModelAfterDataInject(controls: any): void {
    Object.keys(controls).forEach(key => {
      if (controls[key] && this.model[key] && this.model[key] !== controls[key].value) {
        controls[key].setValue(this.model[key], { emitEvent: false });
      }
    });
  }
}
